<template>
    <ErrorLayout>
        <span class="title">500</span>
        <span class="title second">{{ __('Internal Server Error') }}</span>
        <span class="description">{{ __('Oops, something went wrong') }}</span>
        <router-link
            to="/"
            exact=""
            class="button"
        >
            <div class="button-content">
                <img
                    src="@/assets/images/angle-icon.svg"
                    alt=""
                >
                <span class="button-title">{{ __('Go Back') }}</span>
            </div>
        </router-link>
    </ErrorLayout>
</template>

<script>
    import ErrorLayout from '@/components/pages/ErrorLayout'

    export default {
        components: { ErrorLayout },
    }
</script>


